import { render, staticRenderFns } from "./SelectionDrawer.vue?vue&type=template&id=f8896db4&scoped=true"
import script from "./SelectionDrawer.vue?vue&type=script&lang=js"
export * from "./SelectionDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8896db4",
  null
  
)

export default component.exports